import { render } from "./LookbookElementEdit.vue?vue&type=template&id=193913fa"
import script from "./LookbookElementEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./LookbookElementEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Sales/Lookbook/LookbookElementEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "193913fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('193913fa', __exports__)) {
    api.reload('193913fa', __exports__)
  }
  
  module.hot.accept("./LookbookElementEdit.vue?vue&type=template&id=193913fa", () => {
    api.rerender('193913fa', render)
  })

}


export default __exports__